import React from 'react';

import {$} from '../lib/ext-refs';
import BootstrapDialog from '../lib/bootstrap-dialog';
import TextField from '../lib/mdb/text-field';
import _set from 'lodash/set';

// Simple Bootstrap modal scaffolding
// handleClose - when modal is called
class AgentCenterDialog extends BootstrapDialog {
    constructor(props) {
        super(props);
        this.agentCenterPostProcess = this.agentCenterPostProcess.bind(this);
        this.handleUpdateClick = this.handleUpdateClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    /**
     * trim leading zeros from service center number entered
     * @param name
     * @param value
     * @param data
     */
    agentCenterPostProcess(name, value, data) {
        if (value) {
            value = value.replace(/^0+/, '');
            _set(data, 'serviceCenterOverrideNumber', value);
        }
    }


    handleUpdateClick() {
        const {state} = this.props,
            {data} = state,
            {serviceCenterOverrideNumber} = data;

        if(data.serviceCenterOverrideNumber) {
            state.setValues((data) => {
                data.serviceCenterOverrideNumber = data.serviceCenterOverrideNumber.replace(/^0+/, '');
                return data;
            });
        }

        if(!data.serviceCenterOverrideNumber || state.validationState[`serviceCenterOverrideNumber`]){
            return;
        }


        this.props.updateAgentCenter();
        this.closeDialog();
    }

    handleClose() {
        this.props.handleClose();
        this.closeDialog();
    }


    render() {
        const {messages} = this.props.config;
        return (
            <BootstrapDialog
                className="modal mdb-modal fade"
                aria-labelledby="modal-cancel-payment-title"
                aria-hidden="true"
                handleClose={this.handleClose}
            >
                <div className="modal-dialog modal-notify" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="modal-update-agent-center-title">
                                Update Service center
                            </h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true" className="white-text">
                                  <i className="material-icons">{messages["icon.material.close.label"]}</i>
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12">
                                    <p>
                                        Please enter your current service center location
                                    </p>
                                    <div id="service-center-override-container" className="col-xs-12 col-md-6">
                                        <TextField
                                            key="serviceCenterOverrideNumber"
                                            name="serviceCenterOverrideNumber"
                                            description={messages["opp.paymentPreferences.serviceCenter.label"]}
                                            maxLength="7"
                                            className="md-form form-group"
                                            labelClass="active"
                                            placeholder={messages["opp.paymentPreferences.serviceCenter.tip"]}
                                            aria-required="true"
                                            validations={{
                                                required: messages["opp.validation.serviceCenterNumber.required"],
                                                integer: "Please enter numeric Service Center"
                                            }}
                                            autoComplete="off"
                                            postProcess={this.agentCenterPostProcess}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer align-button-between-left">
                            <button
                                type="button"
                                className="btn btn-primary btn-modal-cancel"
                                data-dismiss="modal"
                            >
                                Dismiss
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary waves-effect btn-modal-confirm"
                                onClick={this.handleUpdateClick}
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </BootstrapDialog>
        );
    }
}

export default AgentCenterDialog;